import { Play } from "lucide-react";

// ⚙️ CONFIG: Drop your top Instagram Reels here. Each item needs:
//   • url        — the reel URL (https://www.instagram.com/reel/XXXX/)
//   • thumbnail  — a static image (screenshot the reel cover; save to /public/assets/reels/)
//   • caption    — one-line hook shown under the reel
// Leave the array empty [] to hide this whole section.
const REELS = [
  // {
  //   url: "https://www.instagram.com/reel/XXXXXXXXXXX/",
  //   thumbnail: "/assets/reels/reel-1.jpg",
  //   caption: "Why your morning coffee is wrecking your hormones",
  // },
  // {
  //   url: "https://www.instagram.com/reel/XXXXXXXXXXX/",
  //   thumbnail: "/assets/reels/reel-2.jpg",
  //   caption: "The one protein rule for perimenopause",
  // },
  // {
  //   url: "https://www.instagram.com/reel/XXXXXXXXXXX/",
  //   thumbnail: "/assets/reels/reel-3.jpg",
  //   caption: "3 signs your nervous system is stuck in fight-or-flight",
  // },
];

const InstagramReels = () => {
  if (!REELS.length) return null;

  return (
    <section
      data-testid="reels-section"
      className="py-20 md:py-28 px-6 md:px-12 bg-[#F9F8F6]"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="overline mb-4 block">On Instagram</span>
          <h2 className="font-heading text-3xl md:text-5xl text-[#2C3524] leading-[1.1]">
            See Ivana <span className="text-[#C5A059] italic">in action</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {REELS.map((reel, i) => (
            <a
              key={i}
              href={reel.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`reel-${i}`}
              className="group relative block overflow-hidden rounded-2xl aspect-[9/16] bg-[#2C3524]/5 shadow-[0_10px_40px_rgba(44,53,36,0.12)] hover:shadow-[0_20px_60px_rgba(44,53,36,0.2)] transition-shadow duration-500"
            >
              <img
                src={reel.thumbnail}
                alt={reel.caption}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2C3524]/80 via-[#2C3524]/10 to-transparent" />

              {/* Play glyph */}
              <div className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <Play className="w-4 h-4 text-[#2C3524] fill-[#2C3524] ml-0.5" />
              </div>

              {/* Caption */}
              <p className="absolute bottom-5 left-5 right-5 text-white text-sm md:text-base font-light leading-snug">
                {reel.caption}
              </p>
            </a>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reels-instagram-cta"
            className="inline-block text-[#4A5543] text-sm tracking-[0.2em] uppercase border-b border-[#4A5543]/40 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors pb-1"
          >
            Follow on Instagram
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramReels;
